<template>
  <div class="container">
    <h2 class="mb-5">Configuration</h2>
    <div class="row">
      <form @submit.prevent="handleLogoSubmit">
        <div class="form-group">
          <label for="logoFile">
            Logo:
            <a :href="logoPath" target="_blank">{{logoPath}}</a>
          </label>
          <input
            id="logoFile"
            class="form-control-file form-control-sm"
            type="file"
            @change="processLogo($event)"
          >
        </div>
        <button class="btn btn-success" type="submit">Send logo</button>
      </form>
    </div>
    <hr>
    <div class="row">
      <form @submit.prevent="handleDocSubmit">
        <div class="form-group">
          <label for="logoFile">
            'How to' document:
            <a :href="documentPath" target="_blank">How to</a>
          </label>
          <input
            id="logoFile"
            class="form-control-file form-control-sm"
            type="file"
            @change="processDoc($event)"
          >
        </div>
        <button class="btn btn-success" type="submit">Send document</button>
      </form>
    </div>
    <div class="row mt-3">
      <base-button radius="bl" component-class="blue" @click.native="$router.go(-1)">
        <i class="fas fa-arrow-left mr-3"></i> Back
      </base-button>
    </div>
  </div>
</template>

<script>
    import constances from '@/configs/constances';
    import HTTP from '@/services/HTTP';
    import BaseButton from '@/components/inputs/button/BaseButton';

    export default {
        data() {
            return {
                logo: null,
                document: ''
            };
        },

        computed: {
            logoPath() {
                return this.$store.state.app.logoPath;
            },
            documentPath() {
              return `${constances.domainUrl}/uploads/howto.pdf`;
            }
        },

        methods: {
            async processLogo(event) {
                this.logo = event.target.files[0];
            },
            async processDoc(event) {
                this.document = event.target.files[0];
            },
            prepareFileData(fileType) {
                const formData = new FormData();
                formData.append(fileType, this[fileType]);
                return formData;
            },
            async handleLogoSubmit() {
                const formData = this.prepareFileData('logo');
                try {
                    const { data } = await HTTP.post('/configuration/logo', formData, {
                      headers: {
                          'Content-Type': 'multipart/form-data'
                      }
                    });
                    this.$store.commit('app/setLogoPath', data.path);
                    location.reload(true);
                } catch (error) {
                    console.error(error);
                }
            },
            async handleDocSubmit() {
                const formData = this.prepareFileData('document');
                try {
                    await HTTP.post('/configuration/doc', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    this.$snotify.success('Document uploaded.');
                } catch (error) {
                    console.error(error);
                }
            }
        },

        components: {
            'base-button': BaseButton,
        }
    };
</script>
